// extracted by mini-css-extract-plugin
module.exports = {"blockList":"usuarios_blockList__TGtxo","blockButton":"usuarios_blockButton__odzSU","placeholderShimmer":"usuarios_placeholderShimmer__154Qf"};